import { VedomItem } from "../types/app.types";

export class ApiUtils {
  static normalizeVedomResponse(response: any): VedomItem[] {
    let items: VedomItem[] = [];

    if (response.items && Array.isArray(response.items)) {
      items = response.items;
    } else if (Array.isArray(response)) {
      items = response;
    } else if (response.data && Array.isArray(response.data)) {
      items = response.data;
    } else if (typeof response === "object" && response.id) {
      items = [response];
    }

    return items;
  }

  static extractErrorMessage(error: any, defaultMessage: string): string {
    if (error.response?.data?.message) {
      return error.response.data.message;
    }
    if (error.message) {
      return error.message;
    }
    return defaultMessage;
  }

  static isAuthError(error: any): boolean {
    const status = error.response?.status;
    return status === 401 || status === 403;
  }

  static isServerError(error: any): boolean {
    const status = error.response?.status;
    return status >= 500 && status < 600;
  }

  static isClientError(error: any): boolean {
    const status = error.response?.status;
    return status >= 400 && status < 500 && status !== 401 && status !== 403;
  }

  static isNetworkError(error: any): boolean {
    return !error.response && error.message;
  }

  static getUserFriendlyErrorMessage(error: any): string {
    if (this.isNetworkError(error)) {
      return "Помилка з'єднання з сервером. Перевірте інтернет-з'єднання.";
    }

    if (this.isServerError(error)) {
      return "Помилка сервера. Спробуйте пізніше.";
    }

    if (this.isClientError(error)) {
      return this.extractErrorMessage(error, "Помилка обробки запиту");
    }

    if (this.isAuthError(error)) {
      return "Помилка автентифікації. Увійдіть знову.";
    }

    return this.extractErrorMessage(error, "Невідома помилка");
  }
}
